export default __webpack_public_path__ + "static/media/vacationDays.5422b2fd.png";